import ImageFallback from '@/src/components/helpers/image-fallback/image-fallback'
import { useMerchant } from '@/src/context/merchant/merchant-context'
import React from 'react'
import BaseLoading from '../../helpers/base-loading/base-loading'

interface Props {
    className?: string
}

export default function MerchantCover(props: Props) {
    const { merchantSummary } = useMerchant()

    if (!merchantSummary)
        return (
            <BaseLoading>
                <aside className={props.className} />
            </BaseLoading>
        )

    return (
        <ImageFallback
            src={`${merchantSummary.coverUrl}?v=${merchantSummary?.version}`}
            alt=''
            className={props.className}
            fallbackSrc='https://files.menudino.com/capas/bares-restaurantes-01.webp'
        />
    )
}
